import Text from './text' 
import Response from './response' 


function countdowm(_this, phone, second) {
  if (phone) {
    var num = second;
    let timer = setInterval(function() {
      if (num == 1) {
        _this.second = second;
        _this.disabled = false;
        clearInterval(timer);
        _this.downText = "发送验证码";
      } else {
        _this.disabled = true;
        num--;
        _this.downText = num + "秒后重新发送";
      }
    }, 1000);
  } else {
    _this.downText = "未绑定手机号";
    _this.disabled = true;
  }
}

function getQueryString(_this, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    _this.orderId = unescape(r[2]);
  }
}

function errorLocation(context, err) {
  if (err.Code == 500) {
    console.log(err);
  } else if ((err.status = 401)) {
    context.$router.replace({
      path: "/login?ReturnUrl=" + context.$route.fullPath + "",
    });
  }
}

function getPayState(payState) {
  var _text = "";
  switch (payState) {
    case 0:
      _text = "待付款";
      break;
    case 1:
      _text = "已付款";
      break;
    case 2:
      _text = "已反冲";
      break;
    case 3:
      _text = "已取消";
      break;
    case 4:
      _text = "已完成";
      break;
  }
  return _text;
}

function getApproveStatuText(approveStatus) {
  var _text = "";
  switch (approveStatus) {
    case 0:
      _text = "新添加";
      break;
    case 1:
      _text = "审核通过";
      break;
    case 2:
      _text = "审核驳回";
      break;
    case 3:
      _text = "已编辑";
      break;
    default:
      _text = "新添加";
      break;
  }
  return _text;
}

function getOnlinePaymentTypeText(status) {
  var _text = "未知";
  switch (status) {
    case 1:
      _text = "快钱支付";
      break;
    case 2:
      _text = "易宝支付";
      break;
    case 3:
      _text = "支付宝支付";
      break;
    case 4:
      _text = "手机支付";
      break;
    case 5:
      _text = "财富通支付";
    case 6:
      _text = "微信支付";
      break;
  }
  return _text;
}

export default {
  countdowm: function(_this, phone, second) {
    countdowm(_this, phone, second);
  },
  getQueryString: function(_this, name) {
    getQueryString(_this, name);
  },
  errorLocation: function(_this, err) {
    errorLocation(_this, err);
  },
  getPayState: function(payState) {
    return getPayState(payState);
  },
  getOnlinePaymentTypeText: function(status) {
    return getOnlinePaymentTypeText(status);
  },
  getApproveStatuText: function(approveStatus) {
    return getApproveStatuText(approveStatus);
  },
  Response,
  Text
};
